import React from "react";
import {
    Select,
    MenuItem,
    FormControl,
    Box,
    Typography,
    useTheme,
} from "@mui/material";
import { TiArrowUnsorted } from "react-icons/ti";
import { AiOutlineCheck } from "react-icons/ai";
import { IGenericOptions } from "types/Generics";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setInventoryHealthStockType } from "redux/Filters/reducer";

interface ChartValueItemSelectorProps {
    selectOptions: IGenericOptions[]
}
const StockTypeSelector: React.FC<ChartValueItemSelectorProps> = ({ selectOptions }: ChartValueItemSelectorProps) => {
    const theme = useTheme()

    const selectedOption = useAppSelector(state => state.filter.inventory.stockTypeId)
    const dispatch = useAppDispatch()
    return (
        <FormControl fullWidth>
            <Select
                labelId="period-select-label"
                id="company-select"
                size="small"
                variant="outlined"
                sx={{ width: 'fit-content' }}
                inputProps={{
                    sx: {
                        paddingTop: '0.3rem',
                        paddingBottom: '0.1rem',
                        backgroundColor: theme.palette.background.default

                    }
                }}
                value={selectedOption}
                onChange={(e) => {
                    const selectedOption = selectOptions.find((filter) => filter.id === e.target.value);
                    if (selectedOption)
                        dispatch(setInventoryHealthStockType({ stockTypeId: selectedOption.id as number }));
                }}
                IconComponent={TiArrowUnsorted}
            >
                {selectOptions.map((option) => (
                    <MenuItem key={option.id} value={option.id as number}>
                        <Box display="flex" alignItems="center" gap={'0.3rem'}>
                            <Typography variant="caption">{option.name}</Typography>
                            {selectedOption === option.id && (
                                <AiOutlineCheck fontSize="small" />
                            )}
                        </Box>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default StockTypeSelector;
